var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDaiban = function SvgDaiban(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "url(#daiban_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 23a1.418 1.418 0 0 1-.988-.407A1.38 1.38 0 0 1 8 21.618V10.12a1.38 1.38 0 0 1 .413-.974c.262-.259.616-.405.987-.407h1.178v1.671a1.37 1.37 0 0 0 .401.993 1.405 1.405 0 0 0 .999.416h7.029c.373-.008.729-.16.99-.423.262-.263.41-.617.41-.986V8.74h1.178c.372.004.727.15.99.408.264.258.417.607.425.973v11.498a1.38 1.38 0 0 1-.413.975A1.418 1.418 0 0 1 21.6 23H9.4Zm3.08-6.601a.679.679 0 0 0-.516.466.687.687 0 0 0 .149.685l1.886 2.077a.692.692 0 0 0 1.029.03l3.86-4.14a.747.747 0 0 0-.045-1.035.706.706 0 0 0-.987.043l-3.345 3.59-1.37-1.497a.704.704 0 0 0-.525-.23.807.807 0 0 0-.138.007l.001.004Zm.411-6.043a.898.898 0 0 1-.646-.204.877.877 0 0 1-.31-.596v-.773a.758.758 0 0 1 .117-.39 1.118 1.118 0 0 1 .84-.392h5.271a1.019 1.019 0 0 1 .84.393.7.7 0 0 1 .118.391v.771a.867.867 0 0 1-.31.596.89.89 0 0 1-.648.204h-5.272Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "daiban_svg__a",
    x1: 15.5,
    y1: 0,
    x2: 15.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7567"
  })))));
};

export default SvgDaiban;